<template lang="pug">
.d-flex.justify-center.justify-md-start
  template(v-if="!loading")
    grid-container(cols="3", cols-xs="1", cols-sm="2", justify="center")
      grid-item(col-end-sm="2", col-end-lg="3")
        custom-title(:text="title", type="section")
      article-card.mb-3(
        v-for="({ title, scheduled, text, img, to }, i) in items",
        :key="i",
        :title="title",
        :date="scheduled",
        :text="text",
        :img="img",
        :to="to"
      )
      grid-item.mb-5(col-end-sm="2", col-end-lg="3")
        .d-flex.justify-end
          v-btn.px-8.font-weight-bold.text-none(
            :to="path",
            color="primary",
            depressed
          ) Ver todas
  .py-10.d-flex.justify-center(v-else)
    v-progress-circular(size="50", color="primary", indeterminate)
</template>

<script>
import CustomTitle from "@/components/others/CustomTitle";
import ArticleCard from "@/components/cards/Article";
import { formatToURL } from "@/components/utils.js";

const _config = {
  mod: "articles",
  title: "Mais Notícias",
  path: "/novidades/noticias",
  itemsPerPage: 3,
};

export default {
  data: () => ({
    items: [],
    loading: true,
    title: _config.title,
    path: _config.path,
  }),
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
  },
  created() {
    this.$rest("articles").get({
      params: {
        itemsPerPage: _config.itemsPerPage,
      },
      save: (state, list) => {
        this.items = list.map(({ id, title, scheduled, img, text }) => ({
          title,
          img: this.files + img,
          scheduled,
          text,
          to: `${_config.path}/${formatToURL(title)}-${id}`,
        }));
        this.loading = false;
      },
    });
  },
  components: {
    CustomTitle,
    ArticleCard,
  },
};
</script>
